import Loading from '../../../../Dashboards/Common/Loading';
import { BattalionEvolutionAnual } from './BattalionEvolutionAnual';
import { BattalionEvolutionMonth } from './BattalionEvolutionMonth';
import { CommandEvolutionAnual } from './CommandEvolutionAnual';
import { CommandEvolutionMonth } from './CommandEvolutionMonth';
import { CompanyEvolutionAnual } from './CompanyEvolutionAnual';
import { CompanyEvolutionMonth } from './CompanyEvolutionMonth';
import { useMilitaryChartsDataContext } from './hooks/useMilitaryChartsDataContext';

export const Charts = () => {
    const { isLoading } = useMilitaryChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <BattalionEvolutionAnual />
                <BattalionEvolutionMonth />
            </div>
            <div className="charts-side-by-side-dashboards">
                <CommandEvolutionAnual />
                <CommandEvolutionMonth />
            </div>
            <div className="charts-side-by-side-dashboards">
                <CommandEvolutionAnual />
                <CommandEvolutionMonth />
            </div>
            <div className="charts-side-by-side-dashboards">
                <CompanyEvolutionAnual />
                <CompanyEvolutionMonth />
            </div>
        </>
    );
};
